import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker as MuiTimePicker } from '@mui/x-date-pickers/TimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import dayjs from 'dayjs';
import React from 'react';

import { TimePickerProps } from './TimePicker.props';
import { SizeProps } from '../../../@types';

export const TimePicker: React.FC<TimePickerProps> = ({
  label = 'Time',
  value,
  normalSize = false,
  disabled,
  onChange
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiTimePicker
        disabled={disabled}
        label={label}
        value={dayjs(value, 'h:mma')}
        format="h:mma"
        onChange={(text) => onChange(text?.format('h:mma') || '')}
        sx={{ width: !normalSize ? '130px' : 'auto' } as any}
        slotProps={{
          textField: {
            size: SizeProps.Small,
            placeholder: 'h:mm(a|p)m',
            inputMode: 'text',
            inputProps: {
              autoComplete: 'off',
              'data-mui-mask': 'false'
            }
          }
        } as any}
        viewRenderers={{
          hours: renderTimeViewClock,
          minutes: renderTimeViewClock
        }}
      />
    </LocalizationProvider>
  );
};
